module.exports = __webpack_public_path__ + "img/vector.0658009e.svg";